import { withProps } from '@nobia/zeus-components/lib/recompose'
import galleryPropsChange from './GalleryProps'

const reducer = withProps(({ data }) => ({
  galleryProps: galleryPropsChange({
    data,
  }),
}))

export default reducer
